import { AdminMentorListServices } from "./service";

import {
  MENTOR_LIST,
  VIEW_PREDEFINED_OPTIONS,
  // VIEW_COUNTER_OPTIONS,
  VIEW_MENTORLIST_COUNTER_OPTIONS,
  ADMIN_DASHBOARD_MENTOR_LIST,
} from "../../../../../common/constants/actionConstants";

import { isLoading } from "../../../../../common/dependencies/action/action";

export const getAdminMentorList = (params) => (dispatch) => {
  //
  dispatch(isLoading(true));
  return getBindMentorListData(params).then((data) => {
    //
    const { getMenotrList } = data;
    if (getMenotrList) {
      dispatch({
        type: MENTOR_LIST,
        payload: getMenotrList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getPredefineOptionsList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    //
    const { getPredefineOptionsList } = data;
    if (getPredefineOptionsList) {
      dispatch({
        type: VIEW_PREDEFINED_OPTIONS,
        payload: getPredefineOptionsList,
      });
    }
    dispatch(isLoading(false));
  });
};
export const getMentorlistCountersList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    //
    const { getMentorlistCountersList } = data;
    if (getMentorlistCountersList) {
      dispatch({
        type: VIEW_MENTORLIST_COUNTER_OPTIONS,
        payload: getMentorlistCountersList,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindMentorListData(params) {
  const getMenotrList = await AdminMentorListServices.getMentorList(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getMenotrList,
  };
}
async function getBindData(params) {
  const getPredefineOptionsList =
    await AdminMentorListServices.getPredefineOptionsList().catch((e) => {
      return { data: [], status: false };
    });
  const getMentorlistCountersList =
    await AdminMentorListServices.getMentorlistCountersList().catch((e) => {
      return { data: [], status: false };
    });
  return {
    getPredefineOptionsList,
    getMentorlistCountersList,
  };
}
